import { render, staticRenderFns } from "./CommonSettings.vue?vue&type=template&id=5bee7b98&scoped=true&"
import script from "./CommonSettings.vue?vue&type=script&lang=js&"
export * from "./CommonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee7b98",
  null
  
)

export default component.exports